import Controller, { OnClose, OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../BaseController';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

@Controller({ fragment: 'forget-password-request-success', component: 'root-modal' })
class ForgetPasswordRequestSuccessController extends BaseController {

  @OnClick({ target: ['ok-button'] })
  onButtonClose(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }

  @OnClose({ target: ['root-modal'] })
  onRootModalClose(): void {
    this.historyService.push(APPLICATION_ROUTES.LOGIN);
  }
}

export default ForgetPasswordRequestSuccessController;
